// Etiquetas y helpers compartidos para la vista previa de propiedades.
// Los mapas replican exactamente los usados en EditPropertyForm y en el
// front público (PropertyDetailsView) para mantener una vista fiel.

export const amenityLabels = {
  aireAcondicionado: 'Aire Acondicionado',
  portonAutomatico: 'Portón Automático',
  gimnasio: 'Gimnasio',
  losaRadiante: 'Losa Radiante',
  chimenea: 'Chimenea',
  hidromasaje: 'Hidromasaje',
  seguridad: 'Seguridad',
  pileta: 'Pileta',
  caldera: 'Caldera',
  businessCenter: 'Business Center',
  areaCine: 'Área de Cine',
  cisterna: 'Cisterna',
  laundry: 'Laundry',
  estacionamientoVisitas: 'Estacionamiento de Visitas',
  ascensor: 'Ascensor',
  salonUsosMultiples: 'Salón de Usos Múltiples',
  areaDeJuegosInfantiles: 'Área de Juegos Infantiles',
  canchaTenis: 'Cancha de Tenis',
  recepcion: 'Recepción',
  areasVerdes: 'Áreas Verdes',
  valetParking: 'Valet Parking',
  canchaBasquetbol: 'Cancha de Básquetbol',
  canchaFutbol: 'Cancha de Fútbol',
  canchaPaddle: 'Cancha de Paddle',
  solarium: 'Solarium',
  jardinDeInvierno: 'Jardín de Invierno',
  piletaCubierta: 'Pileta Cubierta',
  piletaClimatizada: 'Pileta Climatizada',
  sauna: 'Sauna',
  bar: 'Bar',
  calefaccion: 'Calefacción',
};

export const characteristicLabels = {
  placard: 'Placard',
  parilla: 'Parrilla',
  desayunador: 'Desayunador',
  orientacionSur: 'Orientación Sur',
  orientacionOeste: 'Orientación Oeste',
  orientacionNorte: 'Orientación Norte',
  orientacionEste: 'Orientación Este',
  accesoDeCocheraRampaFija: 'Acceso de Cochera - Rampa Fija',
  accesoDeCocheraRampaMovil: 'Acceso de Cochera - Rampa Móvil',
  accesoDeCocheraAscensor: 'Acceso de Cochera - Ascensor',
  accesoDeCocheraHorizontal: 'Acceso de Cochera - Horizontal',
  disposicionContrafrente: 'Disposición - Contrafrente',
  disposicionFrente: 'Disposición - Frente',
  disposicionInterno: 'Disposición - Interno',
  disposicionLateral: 'Disposición - Lateral',
  amoblado: 'Amoblado',
  orientacionNoroeste: 'Orientación Noroeste',
  orientacionNoreste: 'Orientación Noreste',
  orientacionSuroeste: 'Orientación Suroeste',
  orientacionSureste: 'Orientación Sureste',
  deck: 'Deck',
  tipoDeCampoOtro: 'Tipo de Campo - Otro',
  tipoDeCampoFruticula: 'Tipo de Campo - Frutícola',
  tipoDeCampoAgricola: 'Tipo de Campo - Agrícola',
  tipoDeCampoChara: 'Tipo de Campo - Chacra',
  tipoDeCampoCriadero: 'Tipo de Campo - Criadero',
  tipoDeCampoTambero: 'Tipo de Campo - Tambero',
  tipoDeCampoFloricultura: 'Tipo de Campo - Floricultura',
  tipoDeCampoForestal: 'Tipo de Campo - Forestal',
  tipoDeCampoGanadero: 'Tipo de Campo - Ganadero',
  tipoDeCampoHaras: 'Tipo de Campo - Haras',
  bodegas: 'Bodegas',
  tipoDeBodegaComercial: 'Tipo de Bodega - Comercial',
  tipoDeBodegaNaveIndustrial: 'Tipo de Bodega - Nave Industrial',
  tipoDeBodegaAlmacen: 'Tipo de Bodega - Almacén',
  biblioteca: 'Biblioteca',
  galpon: 'Galpón',
  sotano: 'Sótano',
  baulera: 'Baulera',
  permiteMascota: 'Permite Mascota',
  aptoTuristico: 'Apto Turístico',
};

export const environmentLabels = {
  dormitorio: 'Dormitorio',
  comedor: 'Comedor',
  vestidor: 'Vestidor',
  jardin: 'Jardín',
  baño: 'Baño',
  patio: 'Patio',
  terraza: 'Terraza',
  estudio: 'Estudio',
  lavadero: 'Lavadero',
  altillo: 'Altillo',
  playroom: 'Playroom',
  lobby: 'Lobby',
  quincho: 'Quincho',
  salaDeReuniones: 'Sala de Reuniones',
  balcon: 'Balcón',
  pileta: 'Pileta',
  cocina: 'Cocina',
  toilette: 'Toilette',
  habitacion: 'Habitación',
  living: 'Living',
  otro: 'Otro',
};

export const serviceLabels = {
  electricidad: 'Electricidad',
  agua: 'Agua',
  gas: 'Gas',
  internet: 'Internet',
  telefono: 'Teléfono',
  desagueCloacal: 'Desagüe Cloacal',
  televisionPorCable: 'Televisión por Cable',
  alarma: 'Alarma',
  televisionSatelital: 'Televisión Satelital',
  aguaCorriente: 'Agua Corriente',
};

export const detailLabels = {
  exclusiveContract: 'Contrato Exclusivo',
  cartel: 'Cartel',
  financing: 'Financiamiento',
  suitableCredit: 'Apto a Crédito',
  commercialSuitable: 'Apto Comercial',
  professionalSuitable: 'Apto Profesional',
  suitableForReducedMobility: 'Apto para Movilidad Reducida',
  pozo: 'Pozo',
  CountryOrPrivateNeighborhood: 'Country o Barrio Privado',
};

export const propertyTypeOptions = [
  { value: 'departamento', label: 'Departamento' },
  { value: 'casa', label: 'Casa' },
  { value: 'ph', label: 'PH' },
  { value: 'local', label: 'Local' },
  { value: 'terrenos y lotes', label: 'Terrenos y lotes' },
  { value: 'campos y chacras', label: 'Campos y chacras' },
  { value: 'fondo de comercio', label: 'Fondo de comercio' },
  { value: 'cochera', label: 'Cochera' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'galpon', label: 'Galpón' },
  { value: 'quinta', label: 'Quinta' },
  { value: 'otro', label: 'Otros' },
];

export const propertyStateOptions = [
  { value: 'aEstrenar', label: 'A Estrenar' },
  { value: 'enConstruccion', label: 'En Construcción' },
  { value: 'refaccionado', label: 'Refaccionado' },
  { value: 'aRefaccionar', label: 'A Refaccionar' },
  { value: 'excelente', label: 'Excelente' },
  { value: 'muyBueno', label: 'Muy Bueno' },
  { value: 'bueno', label: 'Bueno' },
  { value: 'regular', label: 'Regular' },
];

export const currencyOptions = [
  { value: 'USD', label: 'USD' },
  { value: 'ARG', label: 'ARS' },
];

export const commissionTypeOptions = [
  { value: '%', label: '%' },
  { value: 'Fijo', label: '$ Fijo' },
];

// Convierte "true"/"false" (string) o booleanos reales a booleano. Igual que
// el helper isTruthy del front público.
export const isTruthy = (value) => {
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return Boolean(value);
};

// Formatea el precio con separadores de miles (misma lógica que Card/Detail).
export const formatPrice = (price) => {
  if (price === null || price === undefined || price === '') return price;
  const cleaned = price.toString().replace(/\./g, '');
  return cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

// Devuelve las claves cuyo valor es "verdadero" dentro de un objeto de booleanos.
export const getTrueKeys = (obj) =>
  obj && typeof obj === 'object'
    ? Object.keys(obj).filter((key) => isTruthy(obj[key]))
    : [];

export const isLandType = (type) =>
  ['terrenos y lotes', 'campos y chacras'].includes(
    typeof type === 'string' ? type.toLowerCase() : ''
  );

// Tipos de propiedad que muestran el campo "cantidad" (igual que EditPropertyForm).
export const typesWithCantidad = [
  'departamento',
  'ph',
  'local',
  'terrenos y lotes',
  'cochera',
  'oficina',
  'otro',
];

export const getLabelFromOptions = (options, value) => {
  const found = options.find((opt) => opt.value === value);
  return found ? found.label : value || '—';
};

// ¿La URL es un PDF? (para decidir si se embebe en iframe)
export const isPdfUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return url.split('?')[0].toLowerCase().endsWith('.pdf');
};

export const isImageUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return /\.(jpg|jpeg|png|webp|gif)$/i.test(url.split('?')[0]);
};

export const getFileNameFromUrl = (url) => {
  if (!url) return 'documento';
  try {
    const clean = url.split('?')[0].split('#')[0];
    const last = clean.substring(clean.lastIndexOf('/') + 1);
    return decodeURIComponent(last) || 'documento';
  } catch {
    return 'documento';
  }
};

export const isValidYoutubeUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/.test(url.trim());
};
